module.exports = __webpack_public_path__ + "img/ball-triangle.49c8c1d4.svg";